import { useAccount } from 'wagmi';
import { useAppKit } from '@reown/appkit/react';
import { Button, ButtonProps } from '@mantine/core';
import { MdRecommend } from 'react-icons/md';
import { RECOMMEND_HAHA_WALLET } from 'src/constants';

const btnRootChain = [
  'w3m-modal',
  'w3m-router',
  'w3m-connect-view',
  'w3m-wallet-login-list',
  'w3m-connector-list',
];

const walletContainers = [
  'w3m-connect-injected-widget',
  'w3m-connect-featured-widget',
];
const walletSelectors = [
  'wui-list-wallet[name="Phantom"]',
  'wui-list-wallet[name="OKX Wallet"]',
  'wui-list-wallet[name="Backpack"]',
  ...(RECOMMEND_HAHA_WALLET
    ? [`wui-list-wallet[name="${window.haha ? 'HaHa Wallet' : 'HaHa'}"]`]
    : []),
];

const $tag = document.createElement('div');
$tag.setAttribute('class', '__recommend__');
$tag.innerHTML = `<svg stroke="#7C4DFF" fill="#7C4DFF" width="24" height="24" stroke-width="0" viewBox="0 0 24 24" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm6 9.8a.9.9 0 0 1-.1.5l-2.1 4.9a1.34 1.34 0 0 1-1.3.8H9a2 2 0 0 1-2-2v-5a1.28 1.28 0 0 1 .4-1L12 5l.69.69a1.08 1.08 0 0 1 .3.7v.2L12.41 10H17a1 1 0 0 1 1 1z"></path></svg>`;
//$tag.setAttribute('src', '/recommend.svg');
$tag.setAttribute('width', '24');
$tag.setAttribute('height', '24');
$tag.setAttribute('title', 'Recommended');

export function WalletSuspense({
  children,
  fallback,
  buttonProps,
}: {
  children?: React.ReactNode;
  fallback?: React.ReactNode;
  buttonProps?: ButtonProps;
}) {
  const { isConnected } = useAccount();
  const { open } = useAppKit();

  if (isConnected) {
    return children;
  }

  const handleOpenWallet = () => {
    open();

    setTimeout(() => {
      appendWalletRecommendedTags();
    }, 50);
  };

  return (
    fallback || (
      <Button
        variant="gradient"
        {...buttonProps}
        onClick={() => handleOpenWallet()}
      >
        Connect Wallet
      </Button>
    )
  );
}

function appendWalletRecommendedTags(counter = 0) {
  const $modalRoot = document.querySelector(btnRootChain[0])?.shadowRoot;

  if (!$modalRoot?.querySelector(btnRootChain[1])) {
    if (counter > 6) {
      return;
    }

    return setTimeout(() => {
      appendWalletRecommendedTags(counter + 1);
    }, 300);
  }

  setTimeout(() => {
    appendWalletRecommendedTags();
  }, 300);

  let $btnParent: ShadowRoot | null | undefined = $modalRoot;

  for (const selector of btnRootChain.slice(1)) {
    $btnParent = $btnParent?.querySelector(selector)?.shadowRoot;
  }

  if (!$btnParent) {
    return;
  }

  for (const container of walletContainers) {
    const $container = $btnParent.querySelector(container) as HTMLElement;
    const $containerRoot = $container?.shadowRoot;

    if ($containerRoot) {
      $container.style.order = String(
        walletContainers.indexOf(container) - walletContainers.length
      );

      for (const selector of walletSelectors) {
        const $btnContainer = $containerRoot.querySelector(
          selector
        ) as HTMLElement;
        const $btn = $btnContainer?.shadowRoot?.querySelector('button');

        if (!$btn?.querySelector('.__recommend__')) {
          const $clonedTag = $tag.cloneNode(true);
          if ($btn?.querySelector('wui-tag[variant="success"]')) {
            $btn?.insertBefore($clonedTag, $btn.lastElementChild);
          } else {
            $btn?.appendChild($clonedTag);
          }
        }

        if ($btnContainer) {
          $btnContainer.style.order = String(
            walletSelectors.indexOf(selector) - walletSelectors.length
          );
        }
      }
    }
  }
}
